import { useEffect } from 'react';
import { getUtmParams } from '@/utils/getUtmParams';
import { saveUtmParams } from '@/utils/utmStorage';

export const useReferralTracker = () => {

  useEffect(() => {
    const trackReferral = async () => {
      const searchParams = new URLSearchParams(window.location.search);

      const referral = searchParams.get('referral');
      const referer = searchParams.get('referer');
      const medium = searchParams.get('medium');
      const campaign = searchParams.get('campaign');
      saveUtmParams(getUtmParams(searchParams));

      if (!referral && !medium && !campaign && !referer) return;

      const openLink = `${window.location.origin}${window.location.pathname}`;

      const currentData = { referral, referer, medium, campaign, openLink};
      const storedData = JSON.parse(
        localStorage.getItem('referral_data') || 'null'
      );

      const hasChanged =
        JSON.stringify(storedData) !== JSON.stringify(currentData);

      if (hasChanged) {
        localStorage.setItem('referral_data', JSON.stringify(currentData));

        try {
          const res = await fetch('/api/referral', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify(currentData),
          });

          if (!res.ok) {
            console.error('Failed to send referral data, status:', res.status);
          }
        } catch (err) {
          console.error('Network error sending referral data:', err);
        }
      }
    };
    trackReferral();
  }, []);
};
